import "./styles.css";
import "./termly.css";

import { registerAllOpeners } from "@loot-os/react/openers";
import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RevealClaimProvider } from "./components/RevealClaimProvider.js";
import { ShopperProvider } from "./components/ShopperProvider.js";
import { StorefrontRouter } from "./components/StorefrontRouter.js";
import { TenantConfigProvider } from "./components/TenantConfigProvider.js";
import { initAnalytics } from "./lib/analytics.js";
import { queryClient } from "./lib/queryClient.js";
import { initSentry } from "./lib/sentry.js";
import { applyPageTheme } from "./lib/theme.js";
import { router } from "./router.js";

// Every box opens with its opener style's kind; each three.js scene and its stylesheet load on
// first use.
registerAllOpeners();

initSentry(router);
initAnalytics(router);

// The router mounts only once the store's config is in, and would ask for the page's chunk only
// then: the page the shopper landed on starts loading now, beside the config. A failure here is
// left to the router's own load.
for (const route of router.getMatchedRoutes(window.location.pathname)[0]) {
  void router.loadRouteChunk(route)?.catch(() => {});
}

// The stock palette until a store's config (cached or fetched) replaces it, so the splash and the
// store-not-found page are drawn in it rather than in no colors at all.
applyPageTheme(undefined);

const container = document.getElementById("root");
if (!container) throw new Error("missing #root");
createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TenantConfigProvider>
        <ShopperProvider>
          <RevealClaimProvider>
            <StorefrontRouter router={router} />
          </RevealClaimProvider>
        </ShopperProvider>
      </TenantConfigProvider>
    </QueryClientProvider>
  </StrictMode>,
);
